import type { business_hours } from "./business_hours";
import type { Country } from "./country";
import type { LocationType, ValuesOf } from "./enums";
import type { zone } from "./zone";

export type Phone = `+${number}`;
export type Point = `(${number},${number})`;

export interface coordinates {
    point: Point;
}

export interface address extends coordinates {
    externalId: string;
    country: ValuesOf<typeof Country>;
    state: string;
    city: string;
    address: string;
    number: string;
    apartment: string;
    zip: string;
}

export interface location extends address {
    id: string;
    accountId: number;
    locationId: number;
    name: string;
    type: ValuesOf<typeof LocationType>;
    phone: Phone;
    public: boolean;
}

export interface Location extends location {
    hours: business_hours[];
    shifts: { count: number }[];
    zones: zone[]
}

export const transformLocation = (r: Location): location => {
    const { zones, ...rest } = r;
    return rest;
};
